export default "../../src/fonts/garamond/eb-garamond-v15-latin-700.woff";